import { useEffect } from "react";
import Lenis from "lenis";
import { Navbar } from "../components/site/Navbar";
import { Hero } from "../components/site/Hero";
import { MarqueeStrip } from "../components/site/Marquee";
import { Manifesto } from "../components/site/Manifesto";
import { MenuShowcase } from "../components/site/Menu";
import { Quality } from "../components/site/Quality";
import { Branches } from "../components/site/Branches";
import { Locator } from "../components/site/Locator";
import { Footer } from "../components/site/Footer";
import { SeoBranches } from "../components/SeoBranches";

export default function Home() {
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    window.__ssvpLenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      delete window.__ssvpLenis;
    };
  }, []);

  return (
    <>
      <SeoBranches />
      <Navbar />
      <main>
        <Hero />
        <MarqueeStrip />
        <Manifesto />
        <MenuShowcase />
        <Quality />
        <Branches />
        <Locator />
      </main>
      <Footer />
    </>
  );
}
